import React from 'react';
import { useController } from './provider';

export const Field = () => {
    const { renderField, isEditing } = useController();
    return isEditing ? null : (<>{renderField()}</>);
};
